import {
  AssetsAssetIdDeleteRequest,
  AssetsAssetIdPatchRequest,
  AssetsPostRequest,
} from '@nativewaves/nw-cloud-sdk/media'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { MediaAPI } from 'services/api'
import { mediaAssetQueryKeys } from 'services/queryKeys/media'

export const useMediaAssetCreateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: AssetsPostRequest) => MediaAPI.mediaAssets.assetsPost(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.lists() })
    },
  })
}

export const useMediaAssetUpdateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: AssetsAssetIdPatchRequest) => MediaAPI.mediaAssets.assetsAssetIdPatch(params),
    onSuccess: (data) => {
      return Promise.allSettled([
        queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.detail({ assetId: data.id }).queryKey }),
      ])
    },
  })
}

export const useMediaAssetDeleteMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: AssetsAssetIdDeleteRequest) => MediaAPI.mediaAssets.assetsAssetIdDelete(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.lists() })
    },
  })
}
